/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { API_PATH } from "src/environments/config";
// import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class FileUploadService {
  headers: any;
  private fileuploadroute = API_PATH.fileUploadAPI.fileuploadroute;
  private fileuploadBase64route = API_PATH.fileUploadAPI.fileuploadBase64route;

  constructor(private http: HttpClient) {}

  addFiles(attrs, data, businessUnit?) {
    if (attrs.uploadpathkey && attrs.uploadpathkey.nodeValue) {
      data.append("uploadpath", attrs.uploadpathkey.nodeValue.toString());
    }
    if (attrs.orderdata && attrs.orderdata.nodeValue) {
      data.append("orderdata", attrs.orderdata.nodeValue.toString());
    }
    if (attrs.uploadtype && attrs.uploadtype.nodeValue) {
      data.append("uploadtype", attrs.uploadtype.nodeValue.toString());
    }
    if (attrs.fileimport && attrs.fileimport.nodeValue) {
      data.append("fileimport", attrs.fileimport.nodeValue);
    }
    if (businessUnit) {
      data.append("businessunit", businessUnit);
    }
    if (attrs.uploadPath) {
      data.append("uploadpath", attrs.uploadPath.nodeValue.toString());
    }

    return this.http
      .post(this.fileuploadroute, data)
      .pipe(catchError(this.errorMgmt));
  }
  uploadBase64File(data) {
    return this.http.post(this.fileuploadBase64route, data);
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  uploadFiles(attrs, formData) {
    return new Promise((resolve, reject) => {
      if (formData.has("files")) {
        this.addFiles(attrs, formData).subscribe(
          (res) => {
            console.log(res);
            resolve(res["imageURI"]);
          },
          (err) => {
            console.log("error" + err);
            reject(err);
          }
        );
      } else {
        resolve("");
      }
    });
  }
}
